import React from 'react'
import './CustomAlert.component.scss'

const CustomAlert = ({ color = 'info', className = '', children, ...props }) => {
  return (
    <div className={`alert custom-alert alert-${color} ${className}`} role='alert' {...props}>
      {children}
    </div>
  )
}

export default CustomAlert
